import { GoalMetric, goalMetricLabels } from "@sp-crm/core";
import React from "react";
import { MetricBar } from "./metric-bar";
import { goalMetricBarColor, metricPace } from "./pace";

interface MetricCardProps {
    metric: GoalMetric;
    actual: number;
    target: number;
    prior: number;
    frac: number;
}

export const MetricCard: React.FC<MetricCardProps> = ({
    metric,
    actual,
    target,
    prior,
    frac,
}) => {
    const bar = goalMetricBarColor[metric];
    const pace = metricPace(actual, target, frac);
    const pct = target > 0 ? Math.round((actual / target) * 100) : null;
    const delta = actual - prior;
    const deltaColor =
        delta > 0 ? "text-emerald-700" : delta < 0 ? "text-rose-700" : "text-gray-400";
    return (
        <div className="rounded-xl bg-white px-4 py-3.5 shadow-sm ring-1 ring-gray-200">
            <div className="flex items-center gap-2">
                <span className={`inline-block size-2.5 rounded-sm ${bar}`} />
                <span className="text-[12.5px] font-semibold text-zinc-800">
                    {goalMetricLabels[metric]}
                </span>
                <span className="ml-auto inline-flex items-center gap-1 text-[11px] font-semibold">
                    <span className={`size-1.5 rounded-full ${pace.dot}`} />
                    <span className={pace.text}>{pace.label}</span>
                </span>
            </div>
            <div className="mt-2 flex items-baseline gap-1.5">
                <span className="text-[26px] font-bold leading-none tabular-nums text-zinc-950">
                    {actual}
                </span>
                <span className="text-sm text-gray-500">/ {target || "—"}</span>
                {pct !== null ? (
                    <span className="ml-auto inline-flex items-baseline gap-1">
                        <span className="text-[13px] font-bold tabular-nums text-zinc-900">
                            {pct}%
                        </span>
                        <span className="text-[11px] font-normal text-gray-500">
                            complete
                        </span>
                    </span>
                ) : null}
            </div>
            <div className="mt-2.5">
                <MetricBar
                    actual={actual}
                    target={target}
                    bar={bar}
                    frac={frac}
                    height="h-2"
                />
            </div>
            <div className="mt-2 text-[11px] text-gray-500">
                Prior month:{" "}
                <span className="font-semibold tabular-nums text-gray-700">{prior}</span>
                <span className={`ml-1 font-semibold ${deltaColor}`}>
                    ({delta > 0 ? "+" : ""}
                    {delta})
                </span>
            </div>
        </div>
    );
};
